require("inputmask/dist/jquery.inputmask");

window.maskElements = function(parent){
    if(parent == null) {
        parent = $('body');
    }

    parent.find('.mask-cpf').inputmask('999.999.999-99');
    parent.find('.mask-cnpj').inputmask('99.999.999/9999-99');
    // parent.find('.mask-percent').inputmask('##9,99', {reverse: true});
    parent.find('.mask-cep').inputmask('99999-999');
    parent.find('.mask-number').inputmask('9{1,}', {reverse: true});
    parent.find('.mask-date').inputmask('99/99/9999');
    // $('.mask-money').inputmask("#.##9,99", {reverse: true});
    parent.find('.mask-percent').inputmask({
        alias: 'numeric',
        radixPoint: ',',
        groupSeparator: '',
        suffix: '%',
        digits: 2,
        digitsOptional: false,
        placeholder: '0',
        rightAlign: false
    });
    parent.find('.mask-decimal').inputmask({
        alias: 'numeric',
        radixPoint: ',',
        groupSeparator: '',
        suffix: '',
        digits: 2,
        digitsOptional: false,
        placeholder: '0',
        rightAlign: false
    });
    parent.find('.mask-money').inputmask({
        alias: 'numeric',
        radixPoint: ',',
        groupSeparator: '.',
        autoGroup: true,
        prefix: '\R$ ',
        digits: 2,
        digitsOptional: false,
        placeholder: '0',
        rightAlign: false
    });
    parent.find('.mask-ibge-code').inputmask('9999999');
    parent.find('.mask-bank-code').inputmask('999');

    $('.mask-cellphone').inputmask(['(99) 9999-9999', '(99) 99999-9999'], {
        onKeyPress: function (val, e, field, options) {
            field.inputmask(SPMaskBehavior.apply({}, arguments), options);
        }
    });

    $('.mask-cpfcnpj').inputmask(['999.999.999-999','99.999.999/9999-99'],  {
        onKeyPress: function (val, e, field, options) {
            field.inputmask(CpfCnpjMaskBehavior.apply({}, arguments), options);
        }
    });
};
